/**
 * @param addressString
 * @returns {Promise<object>}
 */
function parseAddress(addressString) {
  let parsed = addressString.split(',');
  let data = {};
  if (parsed[0].includes('Unit')) {
    const unit = parsed[0].split(' ');
    data = {
      suite: unit[1],
      firstLine: parsed[1],
      city: parsed[2],
      province: parsed[3],
      postalCode: parsed[4] ? parsed[4].toUpperCase() : ''
    };
  } else {
    data = {
      suite: '',
      firstLine: parsed[0],
      city: parsed[1],
      province: parsed[2],
      postalCode: parsed[3] ? parsed[3].toUpperCase() : ''
    };
  }
  return data;
}

/**
 * @param addressObj
 * @returns {Promise<string|null>}
 */
function generateAddress(addressObj) {
  if (typeof addressObj === 'object') {
    let address = "";
    const addressArr = addressObj.firstLine.split(" ");
    if (addressArr[0].includes('-')) {
      const unitNumberArr = addressArr[0].split("-");
      const suite = unitNumberArr[0];
      const streetNumber = unitNumberArr[1];
      addressArr.shift();
      addressObj.suite = suite;
      addressObj.firstLine = `${streetNumber} ${addressArr.join(' ')}`;
    }
    if (addressObj.postalCode.indexOf(' ') !== 3) {
      let start = addressObj.postalCode.substring(0, 3);
      let end = addressObj.postalCode.substring(3, 6);
      addressObj.postalCode = `${start} ${end}`;
    }
    addressObj.postalCode = addressObj.postalCode.toUpperCase();
    address = addressObj.suite ? `Unit ${addressObj.suite.trim()},${addressObj.firstLine.trim()},${addressObj.city.trim()},${addressObj.province.trim()},${addressObj.postalCode.trim()},Canada` : `${addressObj.firstLine.trim()},${addressObj.city.trim()},${addressObj.province.trim()},${addressObj.postalCode.trim()},Canada`;
    return address;
  }
  let address = addressObj;
  return address;
}
export { parseAddress, generateAddress };